export var NAME_PREFIX = 'data-catalog-sync-result-field';
export var FONT_SIZE = '16px';
//# sourceMappingURL=types.js.map